import generateValidation from 'forms-utils-lib/formField/lib/generateValidation';
import defaultContactFormField from 'forms-utils-lib/formField/constants/defaultContactFormField';
import defaultCompanyFormField from 'forms-utils-lib/formField/constants/defaultCompanyFormField';
import defaultTicketFormField from 'forms-utils-lib/formField/constants/defaultTicketFormField';
import defaultUnknownFormField from 'forms-utils-lib/formField/constants/defaultUnknownFormField';
import { FormFieldPropertyObjectTypesIds } from 'forms-utils-lib/constants/PropertyObjectTypes';
import getPropertyObjectTypeValue from './getPropertyObjectTypeValue';
import isContactField from './isContactField';
import isCompanyField from './isCompanyField';
import isTicketField from './isTicketField';
import isUnknownField from './isUnknownField';
const createFormField = args => {
  const validation = generateValidation(args.name);
  const propertyObjectType = getPropertyObjectTypeValue(args.objectTypeId || FormFieldPropertyObjectTypesIds.CONTACT);
  const overrides = Object.assign({
    validation
  }, args, {
    propertyObjectType
  });
  if (isContactField(args)) {
    return Object.assign({}, defaultContactFormField, overrides);
  }
  if (isCompanyField(args)) {
    return Object.assign({}, defaultCompanyFormField, overrides);
  }
  if (isTicketField(args)) {
    return Object.assign({}, defaultTicketFormField, overrides);
  }
  if (isUnknownField(args)) {
    return Object.assign({}, defaultUnknownFormField, overrides);
  }
  return Object.assign({}, defaultContactFormField, overrides);
};
export default createFormField;